import React, { useEffect, useState, useContext } from 'react';
import UserContext from '../../business/referential/UserContext';

function CertifiedEmailResponse({ Callback }) {    
    const [isResponseReady, setResponseReady] = useState(false);
    const [userData, setUserData] = useState(null);
    const ctx = useContext(UserContext);
    const [pageId, setPageId] = useState(19);

    const getContent = (key) => {
        if (userData) {
            if (userData.dataContent[pageId][key]) {
                return userData.dataContent[pageId][key].contentTxt;
            }
        }
        return '';
    }

    useEffect(() => {

        const process = async () => {

            Promise.resolve(ctx).then(value => {
                setUserData(value);
            });

        }
        process();

    }, []);

    useEffect(() => {
        if (Callback) {
            setResponseReady(true);
        }
    }, [Callback]);

    return (
        <div className="dashboard-container dashboard-container__congratulation">
            <h3 className="mb-2">
                Congratulations
            </h3>
            <p className="mb-4 mb-md-5">Your certified email has been sent!</p>
            <p className="note">
                The certified email has been sent to {isResponseReady && <strong>{Callback.to}</strong>}.
            </p>
            <div style={{ textAlign: "center" }}>
                <img src="/assets/img/envelope-2.svg" style={{ maxWidth: "180px" }} />

                {isResponseReady && <p>
                    <strong>#ID:</strong> {Callback.deposit.number} <br />
                    <strong>Date:</strong> {Callback.deposit.date} <br />
                    <strong>Md5:</strong> {Callback.deposit.md5} <br />
                    <strong>Sha256:</strong> {Callback.deposit.sha256_Base64} <br />
                </p>
                }
            </div>
            <p className="note">
                Once the recipient will read it you will receive a notification that prove that your
                email has been read by entering the password you setted.
            </p>
            <p className="note">
                Thank you for using our certified email service.
            </p>
            <a href="/dashboard" className="btn btn-blue">
                Return to dashboard
            </a>
            <a href="/dashboard" className="arrow-back"></a>
        </div>
    );
}

export default CertifiedEmailResponse;